<template>
  <button
    :disabled="disabled"
    :class="[
      outline ? 'bg-white border' : bg_color,
      full_width ? 'w-full' : '',
      text_color,
      outline ? border_color : '',
      'py-3 rounded text-sm font-bold uppercase shadow outline-none',
    ]"
    @click="click"
    type="button"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "v-button",
  props: {
    theme: {
      type: String,
      default: "success",
    },
    href: {
      type: String,
      default: null,
      required: false,
    },
    disabled: {
      type: Boolean,
    },
    full_width: {
      type: Boolean,
      default: true,
    },
    outline: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    text_color() {
      if (this.outline) {
        return this.disabled
          ? this.theme === "secondary"
            ? "text-primary-disabled"
            : `text-${this.theme}-disabled`
          : this.theme === "secondary"
          ? "text-primary"
          : `text-${this.theme}`;
      }
      return this.theme === "secondary"
        ? this.disabled
          ? "text-primary-disabled"
          : "text-primary"
        : "text-white";
    },
    border_color() {
      if (!this.outline) return "";
      return this.disabled
        ? this.theme === "secondary"
          ? "border-primary-disabled"
          : `border-${this.theme}-disabled`
        : this.theme === "secondary"
        ? "border-primary"
        : `border-${this.theme}`;
    },
  },
  data() {
    return {
      selected_theme: null,
      bg_color: null,
      themes: {
        success: {
          default: "bg-success",
          disabled: "bg-success-disabled",
        },
        error: {
          default: "bg-error",
          disabled: "bg-error-disabled",
        },
        warning: {
          default: "bg-warning",
          disabled: "bg-warning-disabled",
        },
        info: {
          default: "bg-info",
          disabled: "bg-info-disabled",
        },
        secondary: {
          default: "bg-secondary",
          disabled: "bg-secondary-disabled",
        },
      },
    };
  },
  mounted() {
    this.selected_theme = this.themes[this.theme];
    this.bg_color = this.disabled
      ? this.selected_theme.disabled
      : this.selected_theme.default;
  },
  methods: {
    click() {
      if (this.href != null) {
        this.$router.push(this.href);
      }
      this.$emit("clicked");
    },
  },
  watch: {
    disabled() {
      this.bg_color = this.disabled
        ? this.selected_theme.disabled
        : this.selected_theme.default;
    },
    theme(theme) {
      this.selected_theme = this.themes[theme];
      this.bg_color = this.disabled
        ? this.selected_theme.disabled
        : this.selected_theme.default;
    },
  },
};
</script>
